import '../App.css';
import {List, ListItem, Box, Button,  Typography} from '@mui/material/';
import TextInput from '../components/TextInput';
import SingleSelect from '../components/SingleSelect';
import Dropdown from '../components/Dropdown';
import MultiDropdown from '../components/MultiDropdown';
import MultiSelect from '../components/MultiSelect';
import { Navigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';import mentors from './../json/top3mentors';
import languages from './../json/languages'
import sports from './../json/sports'
import universities from './../json/universities'
import axios from "axios";
import Scale from '../components/Scale';
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";

function PostSessionMentorForm() {
    const [error, setError] = useState('')

    const validationSchema = Yup.object().shape({
        q1: Yup.string().required('(This question is required)').test(
            'value', '(This question is required)', (value, validationContext) => {
                let valueNumber = parseInt(value)
                if(Number.isInteger(valueNumber)) {
                    if (value > 0 && value <= 10) return true
                } else {
                    if (value === "did not attend") return true
                }
                return false
            }
        ),
        q2: Yup.string(),
        q3: Yup.string().required('(This question is required)').test(
            'value', '(This question is required)', (value, validationContext) => {
                let valueNumber = parseInt(value)
                if(Number.isInteger(valueNumber)) {
                    if (value > 0 && value <= 10) return true
                } else {
                    if (value === "did not attend") return true
                }
                return false
            }
        ),
        q4: Yup.string(),
        q5: Yup.string().required('(This question is required)').test(
            'value', '(This question is required)', (value, validationContext) => {
                let valueNumber = parseInt(value)
                if(Number.isInteger(valueNumber)) {
                    if (value > 0 && value <= 10) return true
                } else {
                    if (value === "did not attend") return true
                }
                return false
            }
        ),
        q6: Yup.string(),
    });
    
    const { control, handleSubmit, formState: { errors }, setValue} = useForm({ resolver: yupResolver(validationSchema), shouldFocusError: true, mode:'all'});

    const submit = (data) => {
        window.scrollTo(0, 0)
        console.log(data)
        axios.post(constants.serverURL + "submitMenteeSurvey", {data},
            {
                withCredentials: true
            }).then(response => {
                window.location.href = constants.websiteURL + '#/topMentors'
            }).catch((error) => {
                if (error.request.responseText === 'expired token') {
                    window.location.href = constants.websiteURL + '#/refreshToken?redirect=menteeform'
                } else {
                    setError(error.request.responseText)
                }
            })
    }

    const onError = (data) => {
        setError('One or more of the required questions have not been answered')
        window.scrollTo(0, 0)
    }

    let options = ['did not attend', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    let mentee = ['John', 'Sarah', 'Mary']


    return(
        <div>
            <MenuAppBar title="Mentee Survey" signedIn={true}></MenuAppBar>
            <form className='screen'>
                <Box className="box">
                <List>
                    {
                        error &&
                        <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                            <Typography className="font-16 error-message">{error}</Typography>
                        </ListItem>
                    }
                    {mentee[0] &&
                        <div>
                            <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                                <Scale
                                    name={"q1"}
                                    control={control}
                                    question={"1. Was " + mentee[0] + " a good match for you?"}
                                    helper={["Please select a number between 1-10, where 1 is lowest and 10 is highest."]}
                                    options = {options}
                                    required={true}
                                    errors={errors.q1}/>
                            </ListItem>
                            <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                                <TextInput
                                    name={"q2"}
                                    control={control}
                                    question={"2. What else would you like us to know about your match with " + mentee[0] + "?"}
                                    required={false}
                                    errors={errors.q2}/>
                            </ListItem>
                        </div>
                    }
                    {mentee[1] &&
                        <div>
                            <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                                <Scale
                                    name={"q3"}
                                    control={control}
                                    question={"3. Was " + mentee[1] + " a good match for you?"}
                                    helper={["Please select a number between 1-10, where 1 is lowest and 10 is highest."]}
                                    options = {options}
                                    required={true}
                                    errors={errors.q3}/>
                            </ListItem>
                            <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                                <TextInput
                                    name={"q4"}
                                    control={control}
                                    question={"4. What else would you like us to know about your match with " + mentee[1] + "?"}
                                    required={false}
                                    errors={errors.q4}/>
                            </ListItem>
                        </div>
                    }
                    {mentee[2] &&
                        <div>
                            <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                                <Scale
                                    name={"q5"}
                                    control={control}
                                    question={"5. Was " + mentee[2] + " a good match for you?"}
                                    helper={["Please select a number between 1-10, where 1 is lowest and 10 is highest."]}
                                    options = {options}
                                    required={true}
                                    errors={errors.q5}/>
                            </ListItem>
                            <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                                <TextInput
                                    name={"q6"}
                                    control={control}
                                    question={"6. What else would you like us to know about your match with " + mentee[2] + "?"}
                                    required={false}
                                    errors={errors.q6}/>
                            </ListItem>
                        </div>
                    }
                </List>
                <Button type='submit' className="m-form-button" variant="outlined" onClick={handleSubmit(submit, onError)}>Submit</Button>
                </Box>
            </form>
        </div>
    )
}

export default PostSessionMentorForm;